import React from 'react'
import { TitleImageSwitch } from 'components/TitleImageSwitch'
import { ImageCaption } from 'components/ImageCaption'
import { TABox } from 'components/TABox'
import { RelationQuiz } from 'components/RelationQuiz'
import {
  EstimateQuestion,
  Slider,
  Summary,
  ColumnChart,
  BarChart,
  SingleChoice
} from 'components/UserEstimates'

export const Invitro = () => {
  return (
    <div id='invitro' className='chapterwrapper'>
      <TitleImageSwitch
        title='In-vitro-Fleisch'
        sub='Science-Fiction oder schon bald bei dir zuhause?'
        number={2}
        bgpos='center'
        images={[
          require('images/in-vitro_2.jpg'),
          require('images/in-vitro_1.jpg')
        ]}
      />
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <h3>Zutritt nur für «Hightech-Cowboys»!</h3>
            <h5>
              In Wädenswil vermehrt ein Forscherteam im Labor Muskel- und
              Fettzellen vom Rind und stellt daraus erste Fleisch-Prototypen
              her.
            </h5>
            <p>
              Tiefgefroren bei minus 196 Grad Celsius lagern Stammzellen vom
              Rind in einem kleinen, grauen Kühltank. Beim Öffnen des Deckels
              verdampft der flüssige Stickstoff zischend. Durchnummeriert von 1
              bis 10 befinden sich darin die wertvollen Zellisolate in
              beschrifteten Behältern. Es ist das Herzstück, sozusagen der
              biologische Tresor des Schweizer Start-ups Mirai Foods. Denn aus
              diesen Zellen lassen sich nach dem Vorbild der Natur Muskeln und
              Fett herstellen, um schmackhafte Fleischprodukte ohne
              Massentierhaltung und Umweltzerstörung zu produzieren.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/invitro_1.jpg')}
            title={'Schatztruhe mit tierischen Zellen'}
            caption={
              <>
                In diesem Kühltank befinden sich Rinder-Stammzellen, die später
                in einem Bioreaktor zu Muskel- und Fettzellen heranwachsen. Das
                im Labor kultivierte Fleisch soll eine sinnvolle Alternative zu
                konventionellem Fleisch liefern, das gesünder, ethischer und
                besser für unseren Planeten ist.
              </>
            }
            source={'Foto: Barbara Reye'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <p>
              «Für ein Tasting-Event haben wir fünf kleine Mini-Burger kreiert»,
              sagt Christoph Mayr, Mitgründer von Mirai Foods in Wädenswil. Das
              sei das erste Mal, dass in der Schweiz ein vollständig im Labor
              hergestelltes Stück Fleisch gegessen worden sei. Es habe annähernd
              wie das Original geschmeckt und die Textur und Struktur wie
              Gehacktes gehabt. Für die insgesamt 150 Gramm dauerte die
              Produktion 40 Tage. Doch die Kosten sind immer noch viel zu hoch,
              obwohl sie diese von dem Preis eines Autos auf den eines Velos
              bereits gesenkt haben.
            </p>
            <TABox
              title={<>Fleisch aus dem Labor</>}
              caption={
                <>
                  Was für viele gewöhnungsbedürftig klingt, steht vielleicht
                  bald auch bei uns auf dem Speiseplan. Ende 2020 hat Singapur
                  als erster Staat weltweit In-vitro-Fleisch zugelassen. Warum
                  auch dieser Ansatz vielversprechend ist, aber bisher noch
                  nicht massentauglich.
                  <ul>
                    <li>
                      Fleischessen mit gutem Gewissen, ohne sich dabei Sorgen
                      über die Ökologie, den Klimaschutz und das Leid der Tiere
                      zu machen. Dieses Ziel verfolgen derzeit weltweit rund 80
                      Food-Start-ups.
                    </li>
                    <li>
                      Der niederländische Forscher Mark Post stellte den ersten
                      «Retorten-Burger» Mitte 2013 in London vor. Sein Hamburger
                      kostete damals 250’000 Euro und war damit der bisher wohl
                      teuerste der Welt.
                    </li>
                    <li>
                      Die Firma Eat Just hat Chicken Nuggets entwickelt, für die
                      kein Huhn mehr sterben muss. Das unter der Marke Good Meat
                      verkaufte Fleisch wächst stattdessen aus Hühnerstammzellen
                      im Labor heran. In Singapur ist ein solches Menü seit Ende
                      2020 im Club 1880 für 17 Dollar erhältlich.
                    </li>
                  </ul>
                </>
              }
            />
            <p>
              Um eines Tages Millionen von Burgern herzustellen, braucht man
              theoretisch nur von einer einzigen Kuh eine 0,5 Gramm leichte
              Gewebeprobe eines Muskels, beispielsweise vom Bein. Das Tier wird
              an dieser Stelle lediglich lokal betäubt und merkt nichts davon.
              Die Vision ist, dass man in Zukunft Fleisch ohne schlechtes
              Gewissen geniessen kann. Denn das Rind musste dafür nicht im
              Schlachthof mit einem Bolzenschuss zuerst betäubt werden, um
              danach mit einem Schnitt durch die Halsschlagader kopfüber
              auszubluten.
            </p>
            <p>
              Zusammen mit Suman Das, einem ehemaligen Stammzellenforscher von
              Novartis, gründete Mayr 2019 das Start-up Mirai Foods, was auf
              Japanisch «Nahrung der Zukunft» bedeutet. Am Anfang steckte der
              Wirtschaftsingenieur, der zuvor für Delivery Hero in Südkorea den
              lokalen Essenslieferdienst Yogiyo aufbaute, viel Eigenkapital in
              das Unternehmen, das aber inzwischen mehrere Millionen von
              Investoren erhalten hat. «Als werdender Vater machte ich mir
              damals Gedanken, wie die Welt meiner Tochter aussehen würde», sagt
              er. Mit dem bei ihnen produzierten «Clean Meat» wolle er deshalb
              einen Beitrag zum Schutz der Tiere und der Umwelt leisten.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/invitro_2.jpg')}
            title={'Rind als Spender'}
            caption={
              <>
                Ohne dass das Tier dabei Schaden nimmt, wird die kleine
                Gewebeprobe entnommen und anschliessend daraus im Labor Fleisch
                gezüchtet. Diesen Prozess bezeichnet man auch als zellbasierte
                Landwirtschaft.
              </>
            }
            source={'Foto: Mosa Meat'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <p>
              Im ersten Stock der drei Labors von Mirai Foods an der ZHAW in
              Wädenswil arbeiten rund ein Dutzend Zellbiologinnen,
              Stammzellforscher und Biotechnologen. Dort vermehren sich in dem
              einen Raum Muskelzellen in einem Bioreaktor unter Rühren in dem
              Nährmedium. In einem anderen werden sie mit mechanischen Reizen
              durch Ziehen angeregt, um miteinander zu verschmelzen und eine
              echte Muskelfaser zu bilden. «Das ist unser Fitnessgerät», erklärt
              Mayr. Es sei ähnlich wie mit natürlichen Muskeln, die auch
              trainiert werden müssten.
            </p>
            <p>
              Unter dem Mikroskop lässt sich tatsächlich danach beim
              Muskelgewebe kaum ein Unterschied mehr feststellen, ob dieses
              direkt vom Tier stammt oder im Labor erzeugt wurde. Denn es
              enthält unter anderem die wichtigen, fadenförmig aufgebauten
              Muskelproteine Aktin und Myosin, die für das Verkürzen der Muskeln
              und somit für die Bewegung des Körpers wichtig sind.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/invitro_3.jpg')}
            title={'Bioreaktor im Kleinformat'}
            caption={
              <>
                Hier gedeihen die Muskelzellen in einem speziellen Nährmedium.
                Die Vision ist, dass «Cultured-Meat» von Geflügel, Rind, Schwein
                oder Fisch bald auch in grossem Massstab kommerziell produziert
                wird – in Produktionsstätten, die ein wenig an Brauereien
                erinnern.
              </>
            }
            source={'Foto: Barbara Reye'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <p>
              Sehnen, Knochen und Blutgefässe fehlen jedoch im Gewebe der
              Petrischale. Am Schluss werden dann die ebenfalls separat aus
              Stammzellen gewonnenen und in einem anderen Bioreaktor gezüchteten
              Fettzellen mit den zwei bis drei Zentimeter grossen
              Mini-Muskelstückchen zu einem kleinen Hackbällchen vereint. «Wie
              authentisch es letztlich schmeckt, hängt stark von der Qualität
              und Menge des Fetts ab», erklärt Mayr.
            </p>
          </div>
        </div>
        <div className='ui text container'>
          <EstimateQuestion
            articleID={'123456789'}
            questionID={'insects'}
            question={'Würden Sie Laborfleisch essen?'}
            correctAnswer={12}
            // ignoreLocalStorage
            options={[
              'Nein, auf keinen Fall. Es ist ja trotzdem noch Fleisch.',
              'Lieber nicht. Ist mir noch zu futuristisch.',
              'Vielleicht, wenn es nicht mit einem fötalen Kälberserum produziert wird.',
              'Ja, ich könnte mir gut vorstellen, in Zukunft öfter mal ein Stück In-vitro-Fleisch zu essen.',
              'Her damit, ich liebe Fleisch und kann so ohne schlechtes Gewissen mein Steak geniessen.'
            ]}
            askTheQuestion={props => <SingleChoice {...props} />}
            answerTheQuestion={props => (
              <>
                <BarChart {...props} />
                <div className='participants'>
                  Bisher haben <b>{props.answerCount}</b> Personen an der nicht
                  repräsentativen Umfrage teilgenommen.
                </div>
              </>
            )}
            reportsuccess={() => {}}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <p>
              Genau dies wurde bei dem ersten In-vitro-Burger des
              niederländischen Pioniers Mark Post von der Maastricht-Universität
              bei der Degustation 2013 in London kritisiert. Denn es hatte noch
              gar kein Fett drin und schmeckte deshalb fad. Hinzu kam ein im
              Vergleich viel schwerwiegender Kritikpunkt aus Sicht des
              Tierschutzes, weil ein Hauptbestandteil des Nährmediums für das
              Wachstum der Zellen fötales Kälberserum war.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/invitro_4.jpg')}
            title={'Der Pionier Mark Post'}
            caption={
              <>
                Vor kurzem hat Mark Post, Erfinder des weltweit ersten
                Laborburgers, einen weiteren Meilenstein verkündet, da die von
                ihm gegründete Firma Mosa Meat für das Wachstum der Zellen
                inzwischen kein fötales Kälberserum als Nährmedium mehr
                benötigt.
              </>
            }
            source={'Foto: David Parry/PA'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#D1AACF' }}>
            <p>
              «Dieses teure Serum wird in der pharmazeutischen und
              biotechnologischen Forschung häufig gebraucht», erklärt die
              Wissenschaftlerin Sandra Schumann von der Universität Lübeck, die
              aktuell die zellbiologischen Grundlagen zu «Clean Meat» erforscht.
              Um das fötale Blut zu gewinnen, werde im Schlachthaus der Fötus
              von einer trächtigen Milchkuh verwendet. Inzwischen seien die
              Food-Start-ups und Forschenden an den Hochschulen aber daran,
              dieses Nährmedium durch eine Kombination anderer Substanzen zu
              ersetzen. Schliesslich sei es deren Ziel, dass kein Tier dafür
              leiden müsse.
            </p>
            <p>
              Nach eigenen Angaben ist es der von Mark Post 2015 gegründeten
              Firma bereits gelungen, eine Alternative auf pflanzlicher Basis zu
              entwickeln, in dem sie für das Gedeihen der Rinderzellen
              inzwischen Pflanzenprodukte sowie Proteine aus Hefe und Bakterien
              einsetzen. Auch Mirai Foods forscht intensiv an einer Lösung, kann
              aber momentan noch nicht ganz auf fötales Rinderserum verzichten.
              «Wir werden es in der nächsten Zeit sogar auf null reduzieren,
              damit es unseren Tier-ethischen Vorstellungen entspricht», sagt
              Mayr. Ihr erstes Produkt werde 2023 auf den Markt kommen.
            </p>
          </div>
        </div>{' '}
        <div className='ui container'>
          <div className='visual'>
            <RelationQuiz
              colors={['#FFE462', '#202346', '#7A3F77']}
              labels={['In-vitro-Fleisch', 'Rindfleisch']}
              title={
                <>
                  <b>In-vitro-Fleisch vs. Rind</b>
                  <br />
                  Was schätzen Sie?
                </>
              }
              subline={
                <>
                  * Die berechneten Werte sind Durchschnittswerte und können je
                  nach Ausgangslage und Produktionsbedingungen variieren.
                  <br />{' '}
                  <span>
                    Quelle: Fleisch der Zukunft/ Trendanalyse 2020/
                    Umweltbundesamt, Berlin
                  </span>
                </>
              }
              questions={[
                {
                  q: (
                    <>
                      Wie gross ist das <b>Verhältnis der Landflächen*</b>,
                      welche für die Produktion von 1kg In-vitro-Fleisch und 1kg
                      Rindfleisch benötigt werden?
                    </>
                  ),
                  max: 120.5,
                  rel: [1, 119.5],
                  start: 92.77 / 2,
                  a: [0.77, 92],
                  unit: (
                    <>
                      m<sup>2</sup>
                    </>
                  )
                },
                {
                  q: (
                    <>
                      Wie gross ist das{' '}
                      <b>
                        Verhältnis der emittierten Treibhausgase* in CO
                        <sub>2</sub>-Äquivalenten
                      </b>{' '}
                      bei der Produktion von 1 kg In-vitro-Fleisch und 1 kg
                      Rindfleisch?
                    </>
                  ),
                  max: 53.4,
                  rel: [1, 1.3],
                  start: 53.4 / 2,
                  a: [22.9, 30.5],
                  unit: (
                    <>
                      kg CO<sub>2</sub>
                    </>
                  )
                }
              ]}
            />
          </div>
        </div>
        {/* <div className='ui container quiz'>
          <EstimateQuestion
            articleID={'123456789'}
            questionID={'insects'}
            question={'Würden Sie Laborfleisch essen?'}
            correctAnswer={12}
            // ignoreLocalStorage
            options={[
              'Nein, auf keinen Fall. Es ist ja trotzdem noch Fleisch.',
              'Lieber nicht. Ist mir noch zu futuristisch.',
              'Vielleicht, wenn es nicht mit einem fötalen Kälberserum produziert wird.',
              'Ja, ich könnte mir gut vorstellen, in Zukunft öfter mal ein Stück In-vitro-Fleisch zu essen.',
              'Her damit, ich liebe Fleisch und kann so ohne schlechtes Gewissen mein Steak geniessen.'
            ]}
            askTheQuestion={props => <SingleChoice {...props} />}
            answerTheQuestion={props => (
              <>
                <BarChart {...props} />
                <div className='participants'>
                  Bisher haben <b>{props.answerCount}</b> Personen an der nicht
                  repräsentativen Umfrage teilgenommen.
                </div>
              </>
            )}
            reportsuccess={() => {}}
          />
        </div> */}
      </div>
    </div>
  )
}
